module.exports = __webpack_public_path__ + "static/media/google-play-badge.235818b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/google-play-badge.png
// module id = 61
// module chunks = 4